module.exports = __webpack_public_path__ + "img/AI (1).ec63b9d9.png";